
<div class="card mb-4">
    <div class="card-body">
      <h5 class="card-title text-center">Production Details</h5>
      
      <!-- Excel Export Button and Date Range Filter in One Row -->
  <div class="row mb-3">
    <!-- Excel Export Button -->
    <!-- <div class="col-auto">
      <button class="highlight-link" (click)="exportToExcel()">Export to Excel</button>
    </div> -->
    
    <!-- From Date Filter -->
    <div class="col-auto">
      <label for="fromDate" class="form-label">From Date</label>
      <input type="date" id="fromDate" class="form-control" [(ngModel)]="fromDate" (change)="applyDateFilter()">
    </div>
    
    <!-- To Date Filter -->
    <div class="col-auto">
      <label for="toDate" class="form-label">To Date</label>
      <input type="date" id="toDate" class="form-control" [(ngModel)]="toDate" (change)="applyDateFilter()">
    </div>
  </div>
  
  
      <!-- Table -->
      <div class="table-responsive" style="max-height: 900px; overflow-y: auto;">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th (click)="sortTable('Production')">Production
                <span *ngIf="currentSortColumn === 'Production'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('created')">Date
                <span *ngIf="currentSortColumn === 'created'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('ticketno')">Ticket No
                <span *ngIf="currentSortColumn === 'ticketno'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('refNo')">Ref No
                <span *ngIf="currentSortColumn === 'refNo'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('poNo')">PO Number
                <span *ngIf="currentSortColumn === 'poNo'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('clientName')">Customer
                <span *ngIf="currentSortColumn === 'clientName'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('jobName')">Job Name
                <span *ngIf="currentSortColumn === 'jobName'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('orderKgs')">Total Order
                <span *ngIf="currentSortColumn === 'orderKgs'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <!-- <th (click)="sortTable('orderPcs')">Pcs
                <span *ngIf="currentSortColumn === 'orderPcs'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th> -->
              <!-- <th (click)="sortTable('totalDispatched')">Total Dispatch
                <span *ngIf="currentSortColumn === 'totalDispatched'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th> -->
              <!-- <th (click)="sortTable('kgsBal')">Remain Bal
                <span *ngIf="currentSortColumn === 'kgsBal'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th> -->
              <!-- <th (click)="sortTable('status')">Status
                <span *ngIf="currentSortColumn === 'status'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let production of filteredProductions">
              <td>
                <button 
                  [routerLink]="['/prodForm', production._id]" 
                 >
                  Production
                </button>
              </td>
              <td>{{ production.created | date }}</td>
              <td>{{ production.ticketno }}</td>
              <td>{{ production.refNo }}</td>
              <td>{{ production.poNo }}</td>
              <td>{{ production.clientName }}</td>
              <td>{{ production.jobName }}</td>
              <td>{{ production.orderKgs | number: '1.2-2' }}</td>
              <!-- <td>{{ production.orderPcs }}</td> -->
              <!-- <td>{{ production.totalDispatched || 0 }}</td> -->
              <!-- <td>{{ production.kgsBal || 0 }}</td> -->
              <!-- <td [ngClass]="{
                    'text-danger': production.status === 'Repeated Order' || production.status === 'ticketGenerated',
                    'text-primary': production.status === 'Open',
                    'text-success': production.status === 'Closed'
                  }">
                {{ production.status === 'Repeated Order' || production.status === 'ticketGenerated' ? 'Pending' : production.status }}
              </td> -->
            </tr>
            <tr *ngIf="filteredProductions.length === 0">
              <td colspan="8" class="text-center">No Productions available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  